import { Injectable, Signal, computed, inject } from '@angular/core';
import {
    IqTrendlinesFfStateService,
    IqTrendlinesSegmentTrackingService,
} from '@dat/iq-trendlines-ff';
import { IIqTrendlinesSocialStateService } from '../../models';

@Injectable({
    providedIn: 'root',
})
export class IqTrendlinesSocialStateService
    implements IIqTrendlinesSocialStateService
{
    private _ffService: IqTrendlinesFfStateService = inject(
        IqTrendlinesFfStateService,
    );
    private _trackingService: IqTrendlinesSegmentTrackingService = inject(
        IqTrendlinesSegmentTrackingService,
    );
    constructor() {}

    briefDescription(): Signal<string> {
        const description = computed(() => {
            const flag = this._ffService.getFeatureFlagSig(
                'iq_com_trendline_weekly_brief',
            )();
            if (!flag) return '--';
            return flag?.variables?.description as string;
        });
        // example of how to use the tracking service
        // this._trackingService.register();
        // this._trackingService.track('test event');
        return description;
    }
    briefTitle(): Signal<string> {
        const title = computed(() => {
            const flag = this._ffService.getFeatureFlagSig(
                'iq_com_trendline_weekly_brief',
            )();
            if (!flag) return '--';
            return flag?.variables?.title as string;
        });
        return title;
    }
}
